import { useNavigate } from 'react-router-dom';
import { ActionButton } from '../../components/vertical-dot/popper';
import { useEffect } from 'react';

interface EmailTemplateHeaderProps {
  actions: Record<string, any>[];
  navigate: ReturnType<typeof useNavigate>;
  hasMousePosition: boolean;
  resetMousePosition: () => void;
}

interface CellProps {
  row: any;
  cell: any;
  handleRowEdit?: any;
}

const EmailTemplateHeader = ({ actions, navigate, hasMousePosition, resetMousePosition }: EmailTemplateHeaderProps) => {
  useEffect(() => {
    function handleClickOutside(event: any): void {
      if (!(event.target as HTMLElement).className.includes('roles-popovers')) {
        resetMousePosition();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [resetMousePosition]);

  const handleEdit = (id: any, notificationType: any) => {
    navigate(`/email-template/edit/`, {
      state: {
        id,
        notificationType,
      },
    });
  };

  const renderCell = ({ row, cell, ...rest }: CellProps) => {
    return (
      <td>
        <ActionButton
          actions={[
            {
              action: 'Edit',
              onClick: (id: string, rowData: any) => {
                handleEdit(rowData.id, rowData.notificationType);
              },
            },
          ]}
          id={row.original.id}
          rowData={row.original}
          counter={parseInt(row?.id)}
        />
      </td>
    );
  };

  const newActions = [
    ...(actions || []).map((col: any) => {
      if (col.accessor === 'notificationType') {
        return {
          ...col,
          isModalField: true,
          popoverInfo: 'EmailTemplate',
          fields: { id: 'id' },
        };
      }
      return col;
    }),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      renderCell: true,
      isSubHeader: false,
      Cell: renderCell,
    },
  ];

  return newActions;
};

export default EmailTemplateHeader;
